var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Risorsa 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Below",
    className: "cls-1",
    d: "M12.75,12.75l-6-6-6,6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Below-2",
    className: "cls-1",
    d: "M12.75.75l-6,6-6-6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseW);
export default __webpack_public_path__ + "static/media/close_w.b8d916fc0558aaec0989bc6dc52ddc07.svg";
export { ForwardRef as ReactComponent };